import { useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Navigate, useOutlet } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import Navbar from './Navbar/Navbar';
import Sidebar from './Sidebar/Sidebar';
import { AppContext } from '../../../context/appContext';

function Layout() {

  const { viewport } = useContext(AppContext);
  const { user } = useAuth();
  const outlet = useOutlet();

  useEffect(() => {
    console.log("Layout: viewport", viewport);
  }, [viewport])
  return (    
    <>
      {
        !user ? (
          <Navigate to="/" />
        ) : (
          <section className="app-shell">
            <header>
              <Navbar />
            </header>
            <section className="app-shell-body">
              <Row>
                <Col sm={2} className="d-none d-sm-block" >
                  <Sidebar />
                </Col>
                <Col xs={12} sm={10} className="p-4 app-main-content">
                  {outlet}
                </Col>
              </Row>
            </section>
          </section>
        )
      }
    </>
  );
}

export default Layout;
